// src/pages/NotFound.jsx
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full text-center text-gray-700 dark:text-gray-200 p-6">
            <AlertTriangle size={60} className="mb-4 text-yellow-500" />
            <h1 className="text-3xl font-bold mb-2">404 - Página no encontrada</h1>
            <p className="text-gray-500 dark:text-gray-400">
                La ruta que intentas acceder no existe.
            </p>
        </div>
    );
};

export default NotFound;